module.exports = __webpack_public_path__ + "img/Real-Sociedad.5b958536.png";